(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gal-hero-immersive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gal-hero-immersive')) {
    customElements.define('gal-hero-immersive', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.video = this.querySelector('video');
        this.pauseBtn = this.querySelector('[data-pause]');
        this.index = 0;
        this.delay = parseInt(this.dataset.interval, 10) || 6000;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots.forEach((d) => d.addEventListener('click', () => { this.go(+d.dataset.dot); this.restart(); }));
        if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.toggle());
        if (reduce) {
          if (this.video) { this.video.pause(); this.video.removeAttribute('autoplay'); this.setPaused(true); }
          else this.setPaused(true);
          return;
        }
        this.setPaused(false);
        this.addEventListener('focusin', () => this.stop());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.paused || this.start()));
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      go(i) {
        if (!this.slides.length) return;
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, k) => {
          const on = k === this.index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) s.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        });
        this.dots.forEach((d, k) => d.setAttribute('aria-pressed', k === this.index ? 'true' : 'false'));
        const next = this.slides[(this.index + 1) % this.slides.length];
        if (next) next.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      }
      start() {
        this.stop();
        if (this.video) { this.video.play().catch(() => {}); return; }
        if (this.slides.length > 1) this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() { if (!this.paused) this.start(); }
      setPaused(p) {
        this.paused = p;
        if (this.pauseBtn) {
          this.pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
          const what = this.video ? 'la vidéo' : 'le diaporama';
          this.pauseBtn.setAttribute('aria-label', (p ? 'Relancer ' : 'Mettre en pause ') + what);
        }
      }
      toggle() {
        this.setPaused(!this.paused);
        if (this.paused) { this.stop(); if (this.video) this.video.pause(); }
        else this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
